/**
 * Sets focus on `focusEl` if no focus is set, it is focusable and it is contained in `containerEl`.
 */
export function placeFocusInContainer(focusEl: Element, containerEl: Element) {
  const noFocusIsSet = document.activeElement instanceof HTMLBodyElement;
  const focusElIsFocusable = focusEl instanceof HTMLElement;
  const focusElIsInContainer = containerEl?.contains(focusEl);

  if (noFocusIsSet && focusElIsFocusable && focusElIsInContainer) {
    focusEl.focus();
  }
}
